import { render, staticRenderFns } from "./personalResources.vue?vue&type=template&id=7541ce24&scoped=true&"
import script from "./personalResources.vue?vue&type=script&lang=js&"
export * from "./personalResources.vue?vue&type=script&lang=js&"
import style0 from "./personalResources.vue?vue&type=style&index=0&id=7541ce24&prod&scoped=true&lang=css&"
import style1 from "./personalResources.vue?vue&type=style&index=1&id=7541ce24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541ce24",
  null
  
)

export default component.exports